/* eslint-disable*/
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Button,
  Typography,
  Box,
  Paper,
  Divider,
  Link,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useCommunityList from '../../../hooks/useCommunityList';
import useClub from '../../../hooks/useClub';
import AddCircleOutlineSharpIcon from '@material-ui/icons/AddCircleOutlineSharp';
import FilterComponent from '../Amenities/FilterComponent';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
// import Carousel from "react-simply-carousel";
import Carousel from 'react-material-ui-carousel';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { backendLocalUrl, FROM } from '../../../constants/globalConstants';
import ClubGrid from './ClubGrid';
import { InfoOutlined, Search } from '@material-ui/icons';
import Pagination from '@material-ui/lab/Pagination';
// import ajax from '../../../utils/ajaxHelper';
import { getClubsPaginatedApi } from '../../../services/clubService';

// --- URL Query Param Helpers for Club All Filter Persistence ---
const CLUB_ALL_FILTER_STORAGE_KEY = 'clubAllFilters_';

const serializeClubFilters = (filters) => {
  if (!filters || filters.length === 0) return '';
  try {
    const json = JSON.stringify(filters);
    return btoa(unescape(encodeURIComponent(json)));
  } catch (e) {
    console.error('Failed to encode club filters', e);
    return '';
  }
};

const deserializeClubFilters = (searchStr) => {
  const params = new URLSearchParams(searchStr);
  const raw = params.get('cf');
  if (!raw) return [];
  try {
    const json = decodeURIComponent(escape(atob(decodeURIComponent(raw))));
    return JSON.parse(json);
  } catch (e) {
    console.error('Failed to decode club filters from URL', e);
    return [];
  }
};

const saveClubFiltersToStorage = (communityId, filters) => {
  try {
    if (filters && filters.length > 0) {
      sessionStorage.setItem(CLUB_ALL_FILTER_STORAGE_KEY + communityId, JSON.stringify(filters));
    } else {
      sessionStorage.removeItem(CLUB_ALL_FILTER_STORAGE_KEY + communityId);
    }
  } catch (e) {
    // sessionStorage not available
  }
};

const loadClubFiltersFromStorage = (communityId) => {
  try {
    const raw = sessionStorage.getItem(CLUB_ALL_FILTER_STORAGE_KEY + communityId);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};
// --- End URL Query Param Helpers ---

const ClubCommunityAll = ({ communityInfo, isAccessible, publicView, clubsHook }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  const key = 'iFrasCwdJh';

  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const communityId = params?.id;

  // Initialize selectedFilters: check URL first, then sessionStorage fallback
  const initialFiltersFromUrl = deserializeClubFilters(location.search);
  const initialFilters =
    initialFiltersFromUrl.length > 0
      ? initialFiltersFromUrl
      : loadClubFiltersFromStorage(communityId);

  const [filters, setFilters] = useState([]);
  const [communityDetails, setCommunityDetails] = useState(communityInfo);
  const [clubFilterCategories, setClubFilterCategories] = useState([]);
  const [activeClubTypes, setActiveClubTypes] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState(initialFilters);
  const isInitialMount = useRef(true);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [clubs, setClubs] = useState([]);
  const [localLoader, setLocalLoader] = useState(false);
  const [localSearchedText, setLocalSearchedText] = useState('');
  const [localPagination, setLocalPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    limit: 12,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const [items, setItems] = useState([]);
  const [potentialResultsCount, setPotentialResultsCount] = useState(null);
  const [isPotentialResultsCountLoading, setIsPotentialResultsCountLoading] = useState(false);

  // Use the clubs hook if provided, otherwise fallback to old behavior
  const {
    clubs: hookClubs,
    clubFilters,
    loading: hookLoading,
    pagination: hookPagination,
    filters: hookFilters,
    updateFilters,
    goToPage,
  } = clubsHook || {};

  const { getAmenityByType, getCommunityDetailById, getAmenityCategories } = useCommunityList();
  const { getClubsPaginated, getClubCategories } = useClub();

  // Use hook data if available, otherwise fallback to old local state
  const amenities = hookClubs || clubs;
  const loader = clubsHook ? hookLoading || false : localLoader;
  const searchedText = clubsHook ? hookFilters?.search || '' : localSearchedText;
  const pagination = clubsHook ? hookPagination || localPagination : localPagination;
  const filteredAmenities = amenities;

  // Normalize API filter shape (clubTypes) to existing UI shape (clubType)
  const mappedClubFiltersFromApi = (clubFilters || []).map((category) => ({
    ...category,
    clubType: category?.clubTypes || [],
  }));
  const clubFiltersForUI = clubsHook ? mappedClubFiltersFromApi : clubFilterCategories;

  // Map club filter shape to generic FilterComponent shape
  const clubFiltersGrouped = (clubFiltersForUI || []).map((category) => ({
    id: category?.id || category?.clubCategoryId,
    categoryName: category?.clubCategoryName,
    types: (category?.clubType || []).map((type) => ({
      id: type.id,
      typeName: type.clubTypeName,
    })),
  }));

  // Track active club types from the clubs list
  useEffect(() => {
    let activeClubTypesArr = [];
    amenities?.forEach((club) => {
      if (club?.clubTypeId && !activeClubTypesArr.includes(club.clubTypeId)) {
        activeClubTypesArr.push(club.clubTypeId);
      }
      club?.clubTypes?.forEach((type) => {
        if (type?.id && !activeClubTypesArr.includes(type.id)) {
          activeClubTypesArr.push(type.id);
        }
      });
    });
    setActiveClubTypes(activeClubTypesArr);
  }, [amenities]);

  // Map club type names (selectedFilters) to IDs expected by backend
  const mapClubTypeNamesToIds = (typeNames = []) => {
    if (!typeNames || typeNames.length === 0) return [];
    const nameToId = new Map();
    clubFiltersForUI?.forEach((cat) => {
      cat?.clubType?.forEach((t) => {
        if (t?.clubTypeName && t?.id) nameToId.set(t.clubTypeName, t.id);
      });
    });
    return typeNames.map((n) => nameToId.get(n)).filter(Boolean);
  };

  // Fetch clubs with pagination and filters (fallback flow when clubsHook is not provided)
  const fetchClubs = async (page = 1, filters = {}) => {
    try {
      if (!params?.id) return;
      setLocalLoader(true);
      const reqBody = {
        communityId: params.id,
        page,
        limit: 12,
        search: filters.search || '',
        clubTypes: filters.clubTypes || [],
        clubCategories: filters.clubCategories || [],
      };
      const resp = await getClubsPaginated(reqBody);
      if (resp?.status) {
        setClubs(resp.clubsResult || []);
        setLocalPagination(resp.pagination || {});
      }
    } catch (e) {
      console.error('Error fetching clubs:', e);
      setClubs([]);
    } finally {
      setLocalLoader(false);
    }
  };

  const [filteredAmenitiesCount, setFilteredAmenitiesCount] = useState(0);

  // Function to calculate potential result count without applying filters
  const calculatePotentialResultCount = (filters = selectedFilters, searchText = searchedText) => {
    if (clubsHook) {
      return potentialResultsCount ?? pagination?.totalCount ?? 0;
    }

    // Existing fallback kept for backward compatibility
    let potentialResults = clubs || [];

    if (filters.length > 0) {
      potentialResults = potentialResults.filter((club) =>
        filters.every((filter) => filter === club?.clubType?.clubTypeName),
      );
    }

    if (searchText && searchText.trim() !== '') {
      const searchLower = searchText.toLowerCase().trim();
      potentialResults = potentialResults.filter((club) => {
        return (
          club?.clubName?.toLowerCase().includes(searchLower) ||
          club?.clubType?.clubTypeName?.toLowerCase().includes(searchLower) ||
          club?.clubCategory?.clubCategoryName?.toLowerCase().includes(searchLower) ||
          club?.clubDesc?.toLowerCase().includes(searchLower)
        );
      });
    }

    return potentialResults.length;
  };

  const fillCommunityDetails = async () => {
    // This function is now only needed for backward compatibility
    // when clubsHook is not provided
    if (!clubsHook) {
      let communityDetailsResults = [];
      if (params?.id) {
        communityDetailsResults = await getCommunityDetailById({
          communityId: params?.id,
          userId,
        });
        setCommunityDetails(communityDetailsResults.data);
      }
      return communityDetailsResults?.data;
    }
  };

  /* async function fetchAmenities() {
    try {
      // Make your API call here to fetch the initial data
      const response = await getAmenityByType({ communityId: params?.id }); // Replace with your actual API endpoint
      if (response.status === true) {
        // Update the 'amenities' state with the fetched data
        setAmenities(response.amenitiesResult);
      } else {
        console.error('Failed to fetch amenities data');
      }
    } catch (error) {
      console.error('Error fetching amenities data:', error);
    }
  } */

  const fillCommunityCategories = async () => {
    const clubCategoriesArr = await getClubCategories({});
    setClubFilterCategories(clubCategoriesArr.usersResult);
  };

  useEffect(() => {
    fillCommunityDetails();
    fillCommunityCategories();
    if (!clubsHook && params?.id) {
      fetchClubs(1, {});
    }
  }, [params?.id]);

  // When pending filters/search change while the popover is open, fetch exact preview count.
  // This uses get-clubs-paginated totalCount so AND logic is applied server-side.
  useEffect(() => {
    if (!clubsHook || !open || !params?.id) {
      setPotentialResultsCount(null);
      setIsPotentialResultsCountLoading(false);
      return;
    }

    let isMounted = true;
    setIsPotentialResultsCountLoading(true);

    const timeoutId = setTimeout(async () => {
      try {
        const clubTypeIds = mapClubTypeNamesToIds(selectedFilters);
        const response = await getClubsPaginatedApi({
          communityId: params.id,
          page: 1,
          limit: 1,
          search: searchedText,
          clubTypes: clubTypeIds,
          clubCategories: hookFilters?.clubCategories || [],
          featuredOnly: hookFilters?.featuredOnly || false,
        });
        if (isMounted) {
          setPotentialResultsCount(response?.pagination?.totalCount || 0);
        }
      } catch (error) {
        if (isMounted) {
          setPotentialResultsCount(0);
        }
      } finally {
        if (isMounted) {
          setIsPotentialResultsCountLoading(false);
        }
      }
    }, 250);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [
    clubsHook,
    open,
    params?.id,
    selectedFilters,
    searchedText,
    hookFilters?.clubCategories,
    hookFilters?.featuredOnly,
  ]);

  const showPreviewCountLoader =
    clubsHook && selectedFilters.length > 0 && isPotentialResultsCountLoading;

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterSelection = (filter) => {
    // Check if the filter is already selected
    const isFilterSelected = selectedFilters.includes(filter);

    // If the filter is selected, remove it; otherwise, add it
    const updatedFilters = isFilterSelected
      ? selectedFilters.filter((selected) => selected !== filter)
      : [...selectedFilters, filter];

    // Update the selected filters
    setSelectedFilters(updatedFilters);

    document.activeElement.blur();
  };

  const handleSearchChange = (event) => {
    const searchText = event?.target?.value;

    if (!clubsHook) {
      setLocalSearchedText(searchText);
    }

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newTimeout = setTimeout(() => {
      if (clubsHook && updateFilters) {
        updateFilters({ search: searchText });
      } else {
        applyFiltersAndSearch(selectedFilters, searchText);
      }
    }, 300); // 300ms delay for better performance

    setDebounceTimeout(newTimeout);
  };

  // Helper: update URL and sessionStorage with current club filter state
  const updateUrlParams = useCallback(
    (filters) => {
      saveClubFiltersToStorage(communityId, filters);

      const params = new URLSearchParams(location.search);
      const encoded = serializeClubFilters(filters);
      if (encoded) {
        params.set('cf', encoded);
      } else {
        params.delete('cf');
      }
      const searchString = params.toString();
      navigate(`${location.pathname}${searchString ? `?${searchString}` : ''}`, { replace: true });
    },
    [navigate, location.pathname, location.search, communityId],
  );

  const resetFilters = () => {
    setSelectedFilters([]);
    updateUrlParams([]); // Clear URL and sessionStorage
    // Keep the search text - only reset filters
    applyFiltersAndSearch([], searchedText);
  };

  const applyFiltersAndSearch = async (filters = selectedFilters, searchText = searchedText) => {
    if (clubsHook && updateFilters) {
      const clubTypeIds = mapClubTypeNamesToIds(filters);
      updateFilters({
        search: searchText,
        clubTypes: clubTypeIds,
      });
      return;
    }

    const clubTypeIds = mapClubTypeNamesToIds(filters);
    await fetchClubs(1, {
      search: searchText,
      clubTypes: clubTypeIds,
    });
  };

  const applyFiltersAndFetch = () => {
    applyFiltersAndSearch();
    // Persist filters to URL and sessionStorage
    updateUrlParams(selectedFilters);
    // Close the filter popover
    setAnchorEl(null);
  };

  // Auto-apply persisted filters on initial mount once clubFiltersForUI is available
  useEffect(() => {
    if (!isInitialMount.current) return;
    if (!clubFiltersForUI || clubFiltersForUI.length === 0) return;
    if (initialFilters.length === 0) return;

    isInitialMount.current = false;

    // Apply persisted filters
    applyFiltersAndSearch(initialFilters, searchedText);

    // If filters came from sessionStorage (no URL param), sync URL
    if (initialFiltersFromUrl.length === 0) {
      updateUrlParams(initialFilters);
    }
  }, [clubFiltersForUI]);

  useEffect(() => {
    // Update count based on pagination data
    setFilteredAmenitiesCount(pagination?.totalCount || 0);
  }, [pagination]);

  return (
    <Paper className="WhitePaper" component="div">
      <Grid item xs={12}>
        <Box className="FlexSide ViewAllAmenitiesHeader">
          <Box>
            <Link
              className="BackButtonWrapper"
              underline="none"
              href={`/#/app/community-details/${communityDetails?.id}#Section12`}
            >
              <Typography className="BackButton BackButtonMb" variant="body1">
                <ArrowBackIcon color="primary" className="BackButtonArrow" />
                Create your own Club/Connection
              </Typography>
            </Link>
            <Typography variant="body2" className="AddFeatureAmenityLabel">
              Adding clubs and connections helps users see what your community offers and find the
              right fit.
            </Typography>
          </Box>
          <Box className="ViewAllAmenitiesInner">
            <Button
              className="AddFeatureAmenityButton AddFeatureClubButton"
              variant="contained"
              color="primary"
              startIcon={<AddCircleOutlineSharpIcon />}
              href={`/#/app/community-details-edit-add-new-club/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/default`}
            >
              Create your own Club/Connection
            </Button>
          </Box>
        </Box>
      </Grid>

      <Box className="ViewAllAmenitiesInner">
        <Grid item xs={12}>
          {/* <Box className="AlertBoxContainer">
            <InfoOutlined />
            <Box>
              <Typography variant="body1" className="AlertBoxHeading">
                Heads up!
              </Typography>
              <Typography variant="body1" className="AlertBoxSubHeading LightgreyColor">
                Amenity data is automatically categorized based on available data, but some
                classifications may not be a perfect fit. Before featuring an amenity, double-check
                the amenity type aligns with your expectation. If something seems off, you can
                update or adjust as needed.
              </Typography>
            </Box>
          </Box> */}
        </Grid>
        <Grid item xs={12}>
          <TextField
            className="FeatureAmenitySearchBox"
            value={searchedText}
            onChange={handleSearchChange}
            variant="outlined"
            fullWidth
            type="text"
            placeholder="Search available clubs/connections"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search className="GreenColor" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <Typography color="primary" variant="h2" className="BoxHeading">
              Clubs & Connections
            </Typography>
          </Grid>
          {isAccessible && !publicView && (
            <>
              <Grid item xs={12} className="AddAmenityRow">
                <Box className="AddAmenityContentBox">
                  <Typography variant="body2" className="AddLabel">
                    Inputting Clubs helps users find your community when filtering.
                  </Typography>
                  <Button
                    className="AddButtonBox"
                    variant="outlined"
                    color="primary"
                    fullWidth
                    href={`/#/app/community-details-edit-add-new-amenity/${FROM.AMENITIES_LiST}/${communityDetails?.id}/default`}
                    startIcon={<AddCircleOutlineSharpIcon />}
                  >
                    Add An Club/Connection
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} className="AddAmenityDividerRow">
                <Divider className="DividerCD"></Divider>
              </Grid>
            </>
          )}
          <Grid item xs={12} className="">
            <FilterComponent
              resultCount={filteredAmenitiesCount}
              selectedFilters={selectedFilters}
              anchorEl={anchorEl}
              open={open}
              filtersGrouped={clubFiltersGrouped}
              onFilterClick={handleFilterClick}
              onFilterClose={handleFilterClose}
              onFilterSelection={handleFilterSelection}
              onResetFilters={resetFilters}
              onFilterResultClick={applyFiltersAndFetch}
              calculatePotentialResultCount={calculatePotentialResultCount}
              isLoading={loader}
              hasNoFilters={!clubFiltersGrouped || clubFiltersGrouped.length === 0}
              showPreviewCountLoader={showPreviewCountLoader}
              title="Club/Connection Filters"
            />
          </Grid>
        </Grid>
        {!loader ? (
          amenities?.length > 0 ? (
            <Box className="CommonDetailBoxGridSlider">
              <ClubGrid
                filteredAmenities={filteredAmenities}
                amenities={amenities}
                isAccessible={isAccessible}
                publicView={publicView}
                setCommunityDetails={setCommunityDetails}
              />
            </Box>
          ) : (
            <Grid container>
              <Grid item xs={12}>
                <Box className="EmptyNoteBox AmenitiesEmptyNote">
                  <Box className="EmptySearchBox BgFifth">
                    <Typography variant="h3" className="EmptySearchHeading" component="div">
                      No club and connections to show—yet!
                    </Typography>
                    <Typography variant="body1" className="EmptySearchSubHeading" component="div">
                      We’re working on adding great clubs and connections for you to feature in your
                      community. Check back soon! In the meantime, why not feature one yourself?
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )
        ) : (
          'Loading...'
        )}

        {/* Existing condition kept for reference per request */}
        {/* {pagination && pagination.totalPages >= 1 && ( */}
        {pagination && pagination.totalPages > 1 && (
          <Grid container direction="row">
            <Grid item xs={12}>
              <Box className="PaginationWrapper BasicPagination">
                <Typography variant="body2" component="span" className="PaginationNumber">
                  <Box component="span">{(pagination.currentPage - 1) * pagination.limit + 1}</Box>-
                  <Box component="span">
                    {Math.min(pagination.currentPage * pagination.limit, pagination.totalCount)}
                  </Box>{' '}
                  of <Box component="span">{pagination.totalCount}</Box> results
                </Typography>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={(_, page) => {
                    if (clubsHook && goToPage) {
                      goToPage(page);
                      return;
                    }

                    fetchClubs(page, {
                      search: searchedText,
                      clubTypes: mapClubTypeNamesToIds(selectedFilters),
                    });
                  }}
                  color="primary"
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
    </Paper>
  );
};

export default ClubCommunityAll;
